import isInitAppDebugEnabled from './initAppDebugCondition'

export type InitAppDebugStatus = 'ok' | 'error'

export interface InitAppDebugDetail {
  step: string
  status: InitAppDebugStatus
  timestamp: number
  detail?: string
}

export const INIT_APP_DEBUG_EVENT = 'init-app-debug'

export const emitInitAppDebugEvent = (step: string, status: InitAppDebugStatus, detail?: string): void => {
  if (typeof window === 'undefined') return
  if (!isInitAppDebugEnabled()) return
  const payload: InitAppDebugDetail = {
    step,
    status,
    timestamp: performance.now(),
    detail,
  }
  window.dispatchEvent(new CustomEvent<InitAppDebugDetail>(INIT_APP_DEBUG_EVENT, { detail: payload }))
}
